import { mapState } from 'vuex';

export default {
  data: function () {
    return {
      isScrollingDown: false,
      lastScrollDown: 0,
      scrollPos: 0,
      stickPos: 0
    };
  },
  computed: {
    ...mapState({
      scrollLocked: state => state.appContext.scrollLocked,
      isScrollTop: state => state.appContext.isScrollTop
    })
  },
  methods: {
    handleScroll () {
      this.setPageScrollIsTop();
      if (!this.scrollLocked) {
        const headerHeight = 60;
        const buffer = 10;
        const currentScrollTop = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
        if (this.scrollPos < currentScrollTop - buffer && currentScrollTop > headerHeight + headerHeight) {
          if (!this.isScrollingDown) {
            this.$store.dispatch('appContext/setHideHeader', true);
          }

          this.isScrollingDown = true;
          this.lastScrollDown = currentScrollTop;
        } else if (this.scrollPos >= currentScrollTop) {
          if (this.isScrollingDown && (currentScrollTop < (this.lastScrollDown - 400) || currentScrollTop <= headerHeight * 2)) {
            this.$store.dispatch('appContext/setHideHeader', false);
            this.isScrollingDown = false;
          }
        }
        this.scrollPos = currentScrollTop;
      }
    },
    setPageScrollIsTop () {
      const isTop = document.documentElement.scrollTop <= 120;
      if (this.isScrollTop !== isTop) {
        this.$store.dispatch('appContext/setIsScrollTop', isTop);
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted () {
    this.setPageScrollIsTop();
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }

};
